/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Auth_Legal_Last_UpdatedInputs */

const en_auth_legal_last_updated = /** @type {(inputs: Auth_Legal_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated: ${i?.date}`)
};

const pl_auth_legal_last_updated = /** @type {(inputs: Auth_Legal_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last updated: {date}" |
*
* @param {Auth_Legal_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_legal_last_updated = /** @type {((inputs: Auth_Legal_Last_UpdatedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_Last_UpdatedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_legal_last_updated(inputs)
	return en_auth_legal_last_updated(inputs)
});